import { fromJS } from 'immutable';

import {
  LOAD_CAMPAIGN_SUCCESS,
  LOAD_CAMPAIGN_ERROR,
  LOAD_CAMPAIGN,
  LOADING_CAMPAIGN,
  SET_MY_PERMISSION_INFO,
} from './constants';

const initialState = fromJS({
  campaign: {},
  campaignId: null,
  teamDiscussionId: null,
  clientDiscussionId: null,
  partnerAgencyDiscussionId: null,
  teamOrganisationId: null,
  campaignLoadError: null,
  campaignLoading: false,
  myUserRole: null,
  myPermissionId: null,
  myPermissionName: null,
  myCampaignOrganisationId: null,
});

function campaignReducer(state = initialState, action) {
  switch (action.type) {
  case LOAD_CAMPAIGN:
    return state
      .set('campaign', fromJS({}))
      .set('campaignLoadError', null)
      .set('partnerAgencyDiscussionId', null)
      .set('teamDiscussionId', null)
      .set('clientDiscussionId', null)
      .set('campaignId', action.campaignId);
  case LOADING_CAMPAIGN:
    return state
      .set('campaignLoading', true);
  case LOAD_CAMPAIGN_SUCCESS:
    return state
      .set('campaign', action.campaign)
      .set('partnerAgencyDiscussionId', action.campaign.get('partnerAgencyDiscussion'))
      .set('teamDiscussionId', action.campaign.get('teamDiscussion'))
      .set('clientDiscussionId', action.campaign.get('clientDiscussion'))
      .set('teamOrganisationId', action.campaign.getIn(['owner', 'id']))
      .set('campaignLoadError', null)
      .set('campaignLoading', false);
  case LOAD_CAMPAIGN_ERROR:
    return state
      .set('campaignLoadError', action.error)
      .set('campaignLoading', false);
  case SET_MY_PERMISSION_INFO:
    return state
      .set('myUserRole', action.role)
      .set('myPermissionId', action.id)
      .set('myPermissionName', action.name)
      .set('myCampaignOrganisationId', action.organisationId);
  default:
    return state;
  }
}

export default campaignReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/campaign/reducer.js
 **/